var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import { createTheme } from "@mui/material/styles";
import { NPS_CUSTOM_THEME } from "./nps-custom-theme";
export var COLORS = {
    AZUL_GOV: "#034EA2",
    AMARELO_GOV: "#FDB913",
    VERMELHO_GOV: "#EF4123",
    VERDE_GOV: "#007932",
};
// Extraindo cores do tema NPS customizado
var npsColors = NPS_CUSTOM_THEME.cssVariables;
export var theme = createTheme({
    palette: {
        primary: {
            main: npsColors["--sjs-primary-backcolor"] || "#143971",
            dark: npsColors["--sjs-primary-backcolor-dark"] || "rgba(17, 49, 98, 1)",
            light: npsColors["--sjs-primary-backcolor-light"] || "rgba(20, 57, 113, 0.1)",
            contrastText: npsColors["--sjs-primary-forecolor"] || "#ffffff",
        },
        secondary: {
            main: npsColors["--sjs-secondary-forecolor"] || "#3B5BDB",
            light: npsColors["--sjs-secondary-backcolor-light"] || "rgba(231,240,255,0.5)",
            contrastText: npsColors["--sjs-secondary-forecolor"] || "#3B5BDB",
        },
        background: {
            default: npsColors["--sjs-general-backcolor"] || "#ffffff",
            paper: npsColors["--sjs-questionpanel-backcolor"] || "rgba(255, 255, 255, 1)",
        },
        text: {
            primary: npsColors["--sjs-general-forecolor"] || "#1a1a1a",
            secondary: npsColors["--sjs-general-forecolor-light"] || "rgba(0,0,0,0.5)",
        },
        error: {
            main: npsColors["--sjs-special-red"] || "rgba(230, 15, 65, 1)",
            light: npsColors["--sjs-special-red-light"] || "rgba(229, 10, 62, 0.1)",
            contrastText: npsColors["--sjs-special-red-forecolor"] || "rgba(255, 255, 255, 1)",
        },
        success: {
            main: npsColors["--sjs-special-green"] || "rgba(25, 179, 148, 1)",
            light: npsColors["--sjs-special-green-light"] || "rgba(25, 179, 148, 0.1)",
            contrastText: npsColors["--sjs-special-green-forecolor"] || "rgba(255, 255, 255, 1)",
        },
        info: {
            main: npsColors["--sjs-special-blue"] || "rgba(67, 127, 217, 1)",
            light: npsColors["--sjs-special-blue-light"] || "rgba(67, 127, 217, 0.1)",
            contrastText: npsColors["--sjs-special-blue-forecolor"] || "rgba(255, 255, 255, 1)",
        },
        warning: {
            main: npsColors["--sjs-special-yellow"] || "rgba(255, 152, 20, 1)",
            light: npsColors["--sjs-special-yellow-light"] || "rgba(255, 152, 20, 0.1)",
            contrastText: npsColors["--sjs-special-yellow-forecolor"] || "rgba(255, 255, 255, 1)",
        },
    },
    typography: {
        fontFamily: npsColors["--sjs-font-family"] || "Roboto",
        fontSize: parseInt(((_a = npsColors["--sjs-font-size"]) === null || _a === void 0 ? void 0 : _a.replace("px", "")) || "16"),
        h1: {
            fontSize: "64px",
            fontWeight: 700,
            lineHeight: "64px",
            letterSpacing: "0",
        },
        h2: {
            fontSize: "56px",
            fontWeight: 700,
            lineHeight: "56px",
            letterSpacing: "0",
        },
        h3: {
            fontSize: "40px",
            fontWeight: 700,
            lineHeight: "40px",
            letterSpacing: "0",
        },
        h4: {
            fontSize: "32px",
            fontWeight: 700,
            lineHeight: "32px",
            letterSpacing: "0",
        },
        h5: {
            fontSize: parseInt(((_b = npsColors["--sjs-font-questiontitle-size"]) === null || _b === void 0 ? void 0 : _b.replace("px", "")) || "20") + "px",
            fontWeight: 700,
            lineHeight: "32px",
            letterSpacing: "0",
        },
        h6: {
            fontSize: parseInt(((_c = npsColors["--sjs-font-pagedescription-size"]) === null || _c === void 0 ? void 0 : _c.replace("px", "")) ||
                "20") + "px",
            fontWeight: 700,
            lineHeight: "28px",
            letterSpacing: "0",
        },
        body1: {
            fontSize: parseInt(((_d = npsColors["--sjs-font-size"]) === null || _d === void 0 ? void 0 : _d.replace("px", "")) || "16") +
                "px",
            fontWeight: 400,
            lineHeight: "28px",
            letterSpacing: "0",
        },
        body2: {
            fontSize: parseInt(((_e = npsColors["--sjs-font-questiondescription-size"]) === null || _e === void 0 ? void 0 : _e.replace("px", "")) ||
                "14") + "px",
            fontWeight: 400,
            lineHeight: "28px",
            letterSpacing: "0",
        },
    },
    spacing: parseInt(((_f = npsColors["--sjs-base-unit"]) === null || _f === void 0 ? void 0 : _f.replace("px", "")) || "8"),
    shape: {
        borderRadius: 16,
    },
    shadows: [
        "none",
        npsColors["--sjs-shadow-small"] || "3px 4px 3px 0px rgba(0, 0, 0, 0.3)",
        npsColors["--sjs-shadow-medium"] || "0px 4px 12px rgba(0,0,0,0.10)",
        npsColors["--sjs-shadow-large"] || "0px 8px 24px rgba(0,0,0,0.12)",
        npsColors["--sjs-shadow-large"] || "0px 8px 24px rgba(0,0,0,0.12)",
        npsColors["--sjs-shadow-large"] || "0px 8px 24px rgba(0,0,0,0.12)",
        npsColors["--sjs-shadow-large"] || "0px 8px 24px rgba(0,0,0,0.12)",
        npsColors["--sjs-shadow-large"] || "0px 8px 24px rgba(0,0,0,0.12)",
        npsColors["--sjs-shadow-large"] || "0px 8px 24px rgba(0,0,0,0.12)",
        npsColors["--sjs-shadow-large"] || "0px 8px 24px rgba(0,0,0,0.12)",
        npsColors["--sjs-shadow-large"] || "0px 8px 24px rgba(0,0,0,0.12)",
        npsColors["--sjs-shadow-large"] || "0px 8px 24px rgba(0,0,0,0.12)",
        npsColors["--sjs-shadow-large"] || "0px 8px 24px rgba(0,0,0,0.12)",
        npsColors["--sjs-shadow-large"] || "0px 8px 24px rgba(0,0,0,0.12)",
        npsColors["--sjs-shadow-large"] || "0px 8px 24px rgba(0,0,0,0.12)",
        npsColors["--sjs-shadow-large"] || "0px 8px 24px rgba(0,0,0,0.12)",
        npsColors["--sjs-shadow-large"] || "0px 8px 24px rgba(0,0,0,0.12)",
        npsColors["--sjs-shadow-large"] || "0px 8px 24px rgba(0,0,0,0.12)",
        npsColors["--sjs-shadow-large"] || "0px 8px 24px rgba(0,0,0,0.12)",
        npsColors["--sjs-shadow-large"] || "0px 8px 24px rgba(0,0,0,0.12)",
        npsColors["--sjs-shadow-large"] || "0px 8px 24px rgba(0,0,0,0.12)",
        npsColors["--sjs-shadow-large"] || "0px 8px 24px rgba(0,0,0,0.12)",
        npsColors["--sjs-shadow-large"] || "0px 8px 24px rgba(0,0,0,0.12)",
        npsColors["--sjs-shadow-large"] || "0px 8px 24px rgba(0,0,0,0.12)",
        npsColors["--sjs-shadow-large"] || "0px 8px 24px rgba(0,0,0,0.12)",
    ],
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: 16,
                    background: npsColors["--sjs-questionpanel-backcolor"] ||
                        "rgba(255, 255, 255, 1)",
                    borderWidth: 1,
                    borderColor: npsColors["--sjs-border-default"] || "rgba(5, 5, 5, 0.12)",
                    borderStyle: "solid",
                    boxShadow: npsColors["--sjs-shadow-medium"] || "0px 4px 12px rgba(0,0,0,0.10)",
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    textTransform: "none",
                    fontWeight: 500,
                    padding: "10px 24px",
                    boxShadow: "none",
                    "&:hover": {
                        boxShadow: npsColors["--sjs-shadow-small"] ||
                            "3px 4px 3px 0px rgba(0, 0, 0, 0.3)",
                    },
                },
                contained: {
                    backgroundColor: npsColors["--sjs-primary-backcolor"] || "#143971",
                    color: npsColors["--sjs-primary-forecolor"] || "#ffffff",
                    "&:hover": {
                        backgroundColor: npsColors["--sjs-primary-backcolor-dark"] ||
                            "rgba(17, 49, 98, 1)",
                    },
                },
                outlined: {
                    borderColor: npsColors["--sjs-border-default"] || "rgba(5, 5, 5, 0.12)",
                    color: npsColors["--sjs-primary-backcolor"] || "#143971",
                    "&:hover": {
                        borderColor: npsColors["--sjs-primary-backcolor"] || "#143971",
                        backgroundColor: npsColors["--sjs-primary-backcolor-light"] ||
                            "rgba(20, 57, 113, 0.1)",
                    },
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    "& .MuiOutlinedInput-root": {
                        borderRadius: 8,
                        backgroundColor: npsColors["--sjs-questionpanel-backcolor"] ||
                            "rgba(255, 255, 255, 1)",
                        "& fieldset": {
                            borderColor: npsColors["--sjs-border-default"] || "rgba(5, 5, 5, 0.12)",
                        },
                        "&:hover fieldset": {
                            borderColor: npsColors["--sjs-border-inside"] || "rgba(0,0,0,0.12)",
                        },
                        "&.Mui-focused fieldset": {
                            borderColor: npsColors["--sjs-primary-backcolor"] || "#143971",
                            borderWidth: 2,
                        },
                    },
                    "& .MuiInputBase-input": {
                        fontSize: parseInt(((_g = npsColors["--sjs-font-size"]) === null || _g === void 0 ? void 0 : _g.replace("px", "")) || "16") + "px",
                        fontFamily: npsColors["--sjs-font-family"] || "Roboto",
                    },
                    "& .MuiInputLabel-root": {
                        backgroundColor: npsColors["--sjs-questionpanel-backcolor"] ||
                            "rgba(255, 255, 255, 1)",
                        paddingRight: "6px",
                        zIndex: 1,
                        "&.MuiInputLabel-shrink": {
                            backgroundColor: npsColors["--sjs-questionpanel-backcolor"] ||
                                "rgba(255, 255, 255, 1)",
                        },
                    },
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    fontSize: parseInt(((_h = npsColors["--sjs-font-questiontitle-size"]) === null || _h === void 0 ? void 0 : _h.replace("px", "")) ||
                        "20") + "px",
                    fontWeight: 700,
                    color: npsColors["--sjs-general-forecolor"] || "#1a1a1a",
                    marginBottom: 8,
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    fontSize: parseInt(((_j = npsColors["--sjs-font-questiondescription-size"]) === null || _j === void 0 ? void 0 : _j.replace("px", "")) || "14") + "px",
                    color: npsColors["--sjs-general-forecolor-light"] || "rgba(0,0,0,0.5)",
                },
            },
        },
        MuiLinearProgress: {
            styleOverrides: {
                root: {
                    borderRadius: 4,
                    height: 8,
                    backgroundColor: npsColors["--sjs-general-backcolor-dim"] || "#F5F5F5",
                },
                bar: {
                    borderRadius: 4,
                    backgroundColor: npsColors["--sjs-primary-backcolor"] || "#143971",
                },
            },
        },
        MuiStepper: {
            styleOverrides: {
                root: {
                    "& .MuiStepLabel-root .MuiStepLabel-label": {
                        fontSize: parseInt(((_k = npsColors["--sjs-font-size"]) === null || _k === void 0 ? void 0 : _k.replace("px", "")) || "16") + "px",
                        fontWeight: 500,
                        color: npsColors["--sjs-general-forecolor"] || "#1a1a1a",
                    },
                    "& .MuiStepLabel-root.Mui-active .MuiStepLabel-label": {
                        color: npsColors["--sjs-primary-backcolor"] || "#143971",
                        fontWeight: 700,
                    },
                    "& .MuiStepLabel-root.Mui-completed .MuiStepLabel-label": {
                        color: npsColors["--sjs-special-green"] || "rgba(25, 179, 148, 1)",
                    },
                },
            },
        },
        MuiRadio: {
            styleOverrides: {
                root: {
                    color: npsColors["--sjs-border-default"] || "rgba(5, 5, 5, 0.12)",
                    "&.Mui-checked": {
                        color: npsColors["--sjs-primary-backcolor"] || "#143971",
                    },
                },
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    color: npsColors["--sjs-border-default"] || "rgba(5, 5, 5, 0.12)",
                    "&.Mui-checked": {
                        color: npsColors["--sjs-primary-backcolor"] || "#143971",
                    },
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    backgroundColor: npsColors["--sjs-questionpanel-backcolor"] ||
                        "rgba(255, 255, 255, 1)",
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: npsColors["--sjs-border-default"] || "rgba(5, 5, 5, 0.12)",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: npsColors["--sjs-border-inside"] || "rgba(0,0,0,0.12)",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: npsColors["--sjs-primary-backcolor"] || "#143971",
                    },
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    backgroundColor: npsColors["--sjs-secondary-backcolor"] || "#E7F0FF",
                    color: npsColors["--sjs-secondary-forecolor"] || "#3B5BDB",
                    borderRadius: 8,
                    "&:hover": {
                        backgroundColor: npsColors["--sjs-secondary-backcolor-light"] ||
                            "rgba(231,240,255,0.5)",
                    },
                },
            },
        },
        MuiAlert: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                },
                standardSuccess: {
                    backgroundColor: npsColors["--sjs-special-green-light"] || "rgba(25, 179, 148, 0.1)",
                    color: npsColors["--sjs-special-green"] || "rgba(25, 179, 148, 1)",
                },
                standardError: {
                    backgroundColor: npsColors["--sjs-special-red-light"] || "rgba(229, 10, 62, 0.1)",
                    color: npsColors["--sjs-special-red"] || "rgba(230, 15, 65, 1)",
                },
                standardInfo: {
                    backgroundColor: npsColors["--sjs-special-blue-light"] || "rgba(67, 127, 217, 0.1)",
                    color: npsColors["--sjs-special-blue"] || "rgba(67, 127, 217, 1)",
                },
                standardWarning: {
                    backgroundColor: npsColors["--sjs-special-yellow-light"] ||
                        "rgba(255, 152, 20, 0.1)",
                    color: npsColors["--sjs-special-yellow"] || "rgba(255, 152, 20, 1)",
                },
            },
        },
    },
    custom: {
        headerBackcolor: npsColors["--sjs-header-backcolor"] || "#1581D0",
        formBackcolor: npsColors["--sjs-general-backcolor-dim"] || "#F5F5F5",
    },
});
